import { render, staticRenderFns } from "./CourseInPathwayModal.vue?vue&type=template&id=b9b0f976&scoped=true"
import script from "./CourseInPathwayModal.vue?vue&type=script&lang=js"
export * from "./CourseInPathwayModal.vue?vue&type=script&lang=js"
import style0 from "./CourseInPathwayModal.vue?vue&type=style&index=0&id=b9b0f976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b0f976",
  null
  
)

export default component.exports